// Inicio del administrador — hub de navegación a todas las pantallas.
// Antes el admin aterrizaba en /auxiliar (pantalla del repartidor), que sin
// trabajo pendiente se ve vacía y confunde. Solo navegación, cero lógica.
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const SECCIONES: { titulo: string; items: { ruta: string; nombre: string; desc: string }[] }[] = [
  {
    titulo: 'Operación diaria',
    items: [
      { ruta: '/enfermeria/matriz', nombre: 'Enfermería — Matriz', desc: 'Indicar dietas por tiempo de comida (multi-dieta)' },
      { ruta: '/enfermeria', nombre: 'Enfermería — Simple', desc: 'Indicación individual clásica' },
      { ruta: '/auxiliar', nombre: 'Auxiliar', desc: 'Escanear QR, ofertar menú y entregar bandejas' },
      { ruta: '/cocina', nombre: 'Cocina (KDS)', desc: 'Órdenes entrantes → preparación → listas' },
    ],
  },
  {
    titulo: 'Cobro y venta',
    items: [
      { ruta: '/recepcion/cuentas', nombre: 'Cuentas abiertas', desc: 'Saldo en vivo por paciente (dietas + cafetería)' },
      { ruta: '/cafeteria', nombre: 'Cafetería', desc: 'Punto de venta: efectivo o cargo al paciente' },
      { ruta: '/admin/tarifas', nombre: 'Tarifas', desc: 'Precio por dieta y precio default' },
    ],
  },
  {
    titulo: 'Gestión y catálogos',
    items: [
      { ruta: '/nutricionista', nombre: 'Catálogo de nutrición', desc: 'Dietas, menús semanales, platos e ingredientes' },
      { ruta: '/chef', nombre: 'Chef', desc: 'Compras, recetas e inventario' },
      { ruta: '/jefe-cocina', nombre: 'Jefe de cocina', desc: 'Escalaciones de comidas con problema' },
      { ruta: '/admin/reportes', nombre: 'Reportes', desc: 'Indicadores de la operación' },
      { ruta: '/nutricionista/reportes', nombre: 'Reportes de nutrición', desc: 'Indicadores nutricionales' },
    ],
  },
]

export default function AdminHome() {
  const { user, logout } = useAuth()
  return (
    <div className="min-h-screen">
      <header
        className="sticky top-0 z-30 px-6 py-3 flex items-center gap-4"
        style={{
          background: 'linear-gradient(120deg,#143C78,#1E1E3C)',
          borderBottom: '1px solid rgba(140,170,230,.18)',
        }}
      >
        <img
          src="/avante-logo-white.png"
          alt="Avante"
          style={{ height: 33 }}
          onError={(e) => ((e.target as HTMLImageElement).style.display = 'none')}
        />
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-bold leading-tight" style={{ fontFamily: 'Space Grotesk' }}>
            Avante Dietas
          </h1>
          <p className="text-xs text-[#94A0CD]">Panel de administración — {user?.nombre_completo}</p>
        </div>
        <button onClick={logout} className="text-sm text-[#94A0CD] hover:text-white shrink-0">
          Salir
        </button>
      </header>

      <main className="p-4 md:p-6 mx-auto space-y-8" style={{ maxWidth: 1200 }}>
        {SECCIONES.map((s) => (
          <section key={s.titulo}>
            <h2
              className="text-[11px] uppercase tracking-[0.14em] font-semibold mb-3"
              style={{ color: '#8B97C8' }}
            >
              {s.titulo}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {s.items.map((it) => (
                <Link
                  key={it.ruta}
                  to={it.ruta}
                  className="block p-5 transition-transform hover:-translate-y-0.5"
                  style={{
                    background: 'linear-gradient(160deg, rgba(255,255,255,.08), rgba(255,255,255,.03))',
                    border: '1px solid rgba(140,170,230,.18)',
                    borderRadius: 22,
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,.10)',
                  }}
                >
                  <div
                    className="font-bold mb-1"
                    style={{ fontFamily: 'Space Grotesk', color: '#E6EAF7' }}
                  >
                    {it.nombre}
                  </div>
                  <div className="text-xs" style={{ color: '#94A0CD' }}>
                    {it.desc}
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  )
}
